import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { MetaData } from "../Courses/GetAllRequests";
export type TrainingDTO = {
    id: string,
    companyName: string,
    industry: string,
    isTrainingNeeded: boolean,
    areaOfTraining: string,
    numberOfEmployees: string,
    expectedBudget: string,
    contactPerson: string,
    email: string,
    phone: string,
    additionalNote: string,
    instructor: string,
    createdAt: string,
    updatedAt: string
};
type data = {
    currentPage:number;
    totalPages:number;
    totalItems:number;
    metaData:MetaData;
    trainings:TrainingDTO[];
}
type getConsultantsResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: data
};
interface GetStudentsParams {
    page: number;
    limit: number;
    phone?: string;
  }
  
export const GetAllTraining = async ({ page, limit, phone }: GetStudentsParams): Promise<getConsultantsResponse> => {
  try {
    const response = await axios.get(`/training/all` , {
        params: { page, limit, phone },
      });
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
